import React from 'react';
import { RowHeaderTable } from '../../components';
import PrivateVehiclesTable from '../../components/molecules/configuration/privateVehicles/privateVehiclesTable';

const PrivateVehicles: React.FC = () => {
  return (
    <div className="container-body no-padding">
      {}
      <RowHeaderTable name="Lista de Veículos da Casa" />

      {}
      <PrivateVehiclesTable />
    </div>
  );
};

export default PrivateVehicles;

